import _ from 'lodash';
import { toastSaveSuccess } from 'Common/utilities/alert';
import { FIRE_GENERAL_ID } from 'Common/constants/customerCareModules';
import { setCompletionUtil } from '../util/tabTableCommon';

export default class LoadingExclusionsCtrl {
  constructor(
    NgTableParams,
    customerCareInsuranceService,
    customerCareTabsService,
    uiService,
    $uibModal,
    contactInsuranceService,
    insurancePipelineService,
  ) {
    'ngInject';

    this.NgTableParams = NgTableParams;
    this.$uibModal = $uibModal;
    this.toastSaveSuccess = toastSaveSuccess;
    this.customerCareInsuranceService = customerCareInsuranceService;
    this.customerCareTabsService = customerCareTabsService;
    this.contactInsuranceService = contactInsuranceService;
    this.insurancePipelineService = insurancePipelineService;
    this.uiService = uiService;
    this.FIRE_GENERAL_ID = FIRE_GENERAL_ID;
  }

  $onInit() {
    this.isBulkEmailActive = this.customerCareTabsService.isBulkEmailActive();
    this.isLoading = false;
    this.isFromCompleted = false;
    this.totalRecords = 0;
    this.currentPage = 1;
    this.tableData = [];

    this.defaultTableSettings = {
      page: 1,
      count: 10,
      sorting: {
        ReviewDate: 'asc',
      },
    };

    this.loadTableData();
  }

  $onChanges(changes) {
    if (changes.filterUpdateCount) {
      this.currentPage = 1;
      if (this.defaultTableSettings) {
        this.defaultTableSettings.page = 1;
      }
      this.isFromCompleted = false;
      if (this.tableParams) {
        this.tableParams.reload();
      }
    }

    if (changes.refreshCount && this.tableParams) {
      this.tableParams.reload();
    }
  }

  onActionSelected($event) {
    this.onSendModal({ $event });
  }

  markCompleted(item) {
    this.setCompletion(item);
  }

  onItemCheckboxToggled(item) {
    if (this.isBulkEmailActive) {
      this.onTableDataLoaded({ $event: { tableData: this.tableData } });
    } else {
      item.isComplete = item.isChecked;
      this.setCompletion(item);
    }
  }

  gotoContact(familyId) {
    this.viewContact({ $event: { familyId } });
  }

  onPageChange(event) {
    this.defaultTableSettings.page = event.$e.pageNumber;
    this.currentPage = event.$e.pageNumber;
    this.isFromCompleted = false;
    this.tableParams.reload();
  }

  loadTableData() {
    const ctrl = this;
    this.tableParams = new this.NgTableParams(ctrl.defaultTableSettings, {
      counts: [],
      total: 0,
      getData(params) {
        const sortBy = params.orderBy()[0].slice(1);
        const sortOrder = _.values(params.sorting())[0].toUpperCase();
        if (!ctrl.isFromCompleted) {
          ctrl.isLoading = true;
        }

        const newFilter = {
          ...ctrl.filterData,
          sortBy,
          sortOrder,
          pageNumber: ctrl.currentPage,
        };
        return ctrl.customerCareInsuranceService
          .getLoadingExclusionList(newFilter)
          .then((response) => {
            ctrl.isLoading = false;
            ctrl.tableData = response;
            ctrl.tableData.map((item) => {
              item.isComplete = newFilter.isCompleted;
              return item;
            });
            ctrl.totalRecords =
              ctrl.tableData.length && ctrl.tableData[0].totalCount;
            ctrl.onTableDataLoaded({ $event: { tableData: ctrl.tableData } });

            if (ctrl.totalRecords) {
              params.total(ctrl.totalRecords);
            } else {
              params.total(0);
            }
            return ctrl.tableData;
          });
      },
    });
  }

  openInsuranceDetailsModal(item) {
    const promise =
      item.sourceTable === 'POLICY_BENEFIT'
        ? this.contactInsuranceService.insuranceDetailsGet(
            item.familyID,
            item.tableRecordID /* Actually holds BenefitId */,
          )
        : this.insurancePipelineService.getBenefitCover(
            item.tableRecordID /* Actually holds ProviderResultDetailId */,
          );

    promise.then((response) => {
      const modalInstance = this.$uibModal.open({
        templateUrl:
          '/assets/views/contacts/partials/insurance-modal/insurance_existing.html',
        controller: 'InsuranceExistingModalCtrl',
        windowClass: 'insurance-existing-modal',
        backdrop: false,
        keyboard: false,
        size: 'lg',
        resolve: {
          items() {
            // when getting policy details for POLICY_BENEFIT, the entire policy is returned => need to filter out the benefit that is in loading only
            // when getting policy details for PROVIDER_RESULT_DETAIL, only the selected benefit is returned => make it an empty array
            const loadingExclusions =
              item.sourceTable === 'POLICY_BENEFIT'
                ? [
                    ...response.loadingExclusions.filter(
                      (le) => le.benefitId !== item.tableRecordID,
                    ),
                  ]
                : [];
            return {
              data: {
                ...response,
                familyId: item.familyID,
                loadingExclusions: loadingExclusions,
              },
            };
          },
        },
      });

      modalInstance.result.then(() => this.loadTableData());
    });
  }

  setCompletion(item) {
    if (this.uiService.newCustomerCareEvents) {
      this.openInsuranceDetailsModal(item);
    } else {
      setCompletionUtil(this)(item);
    }
  }
}
